export var tabViewDefaultTheme = {
  Root: {
    base: {
      backgroundColor: '$color.neutral.01'
    }
  }
};